export default __webpack_public_path__ + "static/media/fNeutral16.6b9faf36.png";